<style lang="less">
    @import "../../../styles/reset.less";
    @import "../../../styles/common.less";
</style>
<template>
    <div class="copyrightDetails">
        <div class="container">
            <h3 class="page_title">作品登记证书（电子版）订单详情</h3>
            <!--       横幅状态        -->
            <div v-if="details.orderStatus=='reject' || details.orderStatus=='reject_editable' "
                 class="audit_status error">
                <span class="audit_text">{{ '驳回原因：'+ details.rejectReason }}</span>
            </div>
            <ul class="details_group">
                <li class="details_item">
                    <h3 class="details_group_title">作品基本信息
                        <!--                        <span v-if="downloadFlag" @click="downloadHandle" class="title_right">下载作品文件</span>-->
                        <a v-if="details.orderStatus == 'cert_sign_issue' && details.certUrl!='' "
                           :href="details.certUrl" target="_blank" class="title_right">下载证书</a>
                    </h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">作品名称：</span><span class="item_list_content">{{ details.workFullname }}</span>
                            <span class="item_list_title">作品类型：</span><span class="item_list_content">{{ details.workTypeDescCn }}</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">权利取得：</span><span class="item_list_content">{{ details.powerBy == 1? '原始取得' : details.powerBy == 2 ? '承受' : details.powerBy == 3 ? '继承' : details.powerBy == 4 ? '其他' :''  }}</span>
                            <span class="item_list_title">权利归属：</span><span>{{ details.copyrightType == 1 ? '个人作品' : details.copyrightType == 2 ? '合作作品' : details.copyrightType == 3 ? '法人作品' : details.copyrightType == 4 ? '职务作品' : details.copyrightType == 5 ? '委托作品' : '' }}</span>
                        </li>
                      <li class="details_content_item_list">
                        <span class="item_list_title">作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者：</span><span
                          class="item_list_content">{{ details.authorName }}</span>
                      </li>
                      <li class="details_content_item_list">
                        <span class="item_list_title">著作权人：</span><span>{{ details.powerName }}</span>
                      </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品创作信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">创作开始时间：</span>
                            <span class="item_list_content">{{ details.completeBegin ? details.completeBegin : '-'  }}</span>
                            <span class="item_list_title">创作完成时间：</span><span
                                class="item_list_content">{{ details.completeDate ? details.completeDate : '' }}</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">创作地点：</span>
                            <span class="item_list_content" v-if="details.completeCountry == '其他' ">{{ details.completeCity ? details.completeCity  : '-' }}</span>
                            <span v-else class="item_list_content">{{(details.completeCountry ? details.completeCountry : '') + (details.completeProvince ? '-' + details.completeProvince  : '' ) + (details.completeCity ? '-' + details.completeCity  : '' ) }}</span>
                            <span class="item_list_title">修改次数：</span><span>{{ details.modifyNum ? details.modifyNum : '-' }}</span>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品发表信息</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <span class="item_list_title">发表状态：</span><span class="item_list_content">{{ details.publishStatus == 1 ? '已发布' : '未发布' }}</span>
                            <span class="item_list_title">首次发表时间：</span><span class="item_list_content">{{ details.publishStatus == 1 ?  details.publishDate && details.publishDate!='' ? details.publishDate : '' : '-'  }}</span>
                        </li>
                        <li class="details_content_item_list">
                            <span class="item_list_title">首次发表地点：</span>
                            <span class="item_list_content"
                                  v-if="details.publishStatus == 1 && details.publishCountry == '其他' ">{{ details.publishCity ? details.publishCity : '-' }}</span>
                            <span class="item_list_content" v-else>{{(details.publishStatus == 1 ?  (details.publishCountry ? details.publishCountry : '' ) + (details.publishProvince ? '-' + details.publishProvince : '' )+ (details.publishCity ? '-' + details.publishCity : '') : '-')   }}</span>

                          <span class="item_list_title">已发表的截图或照片：</span>
                          <span class="item_list_content" v-if="details.publishStatus == 1 && details.publishPlatform != '' ">
                            <a :href="details.publishPlatform" target="_blank" class="item_list_desc">截图</a>
                          </span>
                          <span class="item_list_content" v-else></span>
                        </li>
                    </ol>
                </li>
                <li v-if="workList && workList.length>0 && details.subBizType == '0202'" class="details_item">
                    <h3 class="details_group_title">作品文件</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <div v-for="(item,index) in workList" :key="index" class="item_list_img">
                                <img :src="item.url" :alt="item.name">
                                <a :href="item.attachmentUrl" target="_blank" class="item_list_desc">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>
              <li v-if="productImageList && productImageList.length>0" class="details_item">
                <h3 class="details_group_title">作品展示图</h3>
                <ol class="details_content_item">
                  <li class="details_content_item_list">
                    <div v-for="(item,index) in productImageList" :key="index" class="item_list_img">
                      <img :src="item.url" :alt="item.name">
                      <a :href="item.attachmentUrl" target="_blank" class="item_list_desc">{{item.name}}</a>
                    </div>
                  </li>
                </ol>
              </li>
              <li v-if="autGuarAnnexList && autGuarAnnexList.length>0" class="details_item">
                <h3 class="details_group_title">权利保证书</h3>
                <ol class="details_content_item">
                  <li class="details_content_item_list">
                    <div v-for="(item,index) in autGuarAnnexList" :key="index" class="item_list_img">
                      <img :src="item.url" :alt="item.name">
                      <a :href="item.attachmentUrl" target="_blank" class="item_list_desc">{{item.name}}</a>
                    </div>
                  </li>
                </ol>
              </li>
                <li class="details_item">
                    <h3 class="details_group_title">创作意图</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">{{ details.creationIntentions ? details.creationIntentions
                                :'' }}</p>
                        </li>
                    </ol>
                </li>
                <li class="details_item">
                    <h3 class="details_group_title">作品独创性</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p class="item_list_paragraph">{{ details.creationOriginality ? details.creationOriginality
                                : '' }}</p>
                        </li>
                    </ol>
                </li>
                <li v-if="DecFile.length>0" class="details_item">
                    <h3 class="details_group_title">创作声明</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <p>未经合法授权，任何单位和个人不得进行复制、转载、改编或其它侵权行为。</p>
                        </li>
                        <li class="details_content_item_list img_group">
                            <div v-for="(item,index) in DecFile" class="item_list_img">
                                <img src="@/assets/file_icon2.png" alt='版权登记'>
                                <a :href="item.url" target="_blank" class="item_list_desc">{{item.name}}</a>
                            </div>
                        </li>
                    </ol>
                </li>
                <li v-if="details.cerImgPrivateUrl && details.cerImgPrivateUrl!='' " class="details_item">
                    <h3 class="details_group_title">登记证书</h3>
                    <ol class="details_content_item">
                        <li class="details_content_item_list">
                            <div class="cert_box">
                                <img :src="details.cerImgPrivateUrl" alt='版权登记'>
                                <a v-if="details.certUrl && details.certUrl!='' " :href="details.certUrl"
                                   target="_blank" class="download_btn">下载证书</a>
                            </div>
                        </li>
                    </ol>
                </li>
            </ul>
        </div>
       <div class="evidenceInfo" v-if="details.insurance && details.insurance.insuranceStatus == 1">
            <div class="evidenceInfo-top" style="min-height:357px">
                <div class="evidenceInfo-top-title">登记保险</div>
                <div class="evidence-bottom">
                    <div style="width:166px;margin-right:20px"><img src="../insurance/images/baoxian.png" alt='版权登记'/></div>
                    <div class="evidence-bottom-right">
                        <p class="p-one">{{ details.workFullname?details.workFullname+'-':'' }}登记保险 </p>
                        <ul class="evidence-bottom-ul">
                            <li>
                                <span style="width:70px">保单状态：</span>
                                <span>{{details.insurance.insuranceStatus == 1 ? "已生效":""}}</span>
                            </li>
                            <li>
                                <span style="width:70px">保险编号：</span>
                                <span>{{details.insurance.policyNo}}</span>
                            </li>
                            <li>
                                <span style="width:100px">投保保险公司：</span>
                                <span>国任保险</span>
                            </li>
                            <li>
                                <span style="width:88px">保险有效期：</span>
                                <span>{{details.insurance.startDate}}至{{details.insurance.endDate}}</span>
                            </li>
                        </ul>
                        <div>
                            <button class="btn-76" @click="baodanVerify">保单核验</button>
                            <button class="btn-76" style="margin:0px 15px" @click="downBook(details.insurance.policyUrl)">下载保单
                            </button>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
    import download from 'ly-downloader'
    import {_getDetail} from '@/api/register.js'
    import util from "../../../libs/util";

    const reImg = /^(bmp|BMP|png|PNG|jpg|JPG|gif|GIF|jpeg|JPEG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;


    export default {
        metaInfo: {
            title: '登记详情|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '监测详情,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "copyrightDetails",
        data() {
            return {
                copyrightDetailsId: '',
                details: [], //登记详情
                downloadFlag: false, //是否可下载
                downloadList: [], //下载列表
                DecFile: [], //创作声明文件
                workList: [], //作品文件列表
                productImageList: [], //作品展示图
                autGuarAnnexList: [], //权利保证书
                music: require('@/assets/common/music_icon.png'),
                text: require('@/assets/common/text_icon.png'),
                video: require('@/assets/common/video_icon.png'),
                other: require('@/assets/common/file_icon.png')
            }
        },
        created() {
            if (this.$route.query.id && this.$route.query.id != '') {
                this.copyrightDetailsId = this.$route.query.id;
                this.getDetail();
            }
        },
        methods: {
            baodanVerify() {
               window.open("http://www.guorenpcic.com/web/bdyz/index.jhtml", '_blank');
            },
            //下载保单
            downBook(url){
                window.open(url, '_blank')
            },
            /************获取登记详情***********/
            getDetail() {
                let data = {orderSeqNo: this.copyrightDetailsId};
                _getDetail(data).then(res => {
                    if (res.code == 200) {
                        this.details = res.result;
                        this.checkDownloadUrl();
                        this.DecFileFuc();
                        this.handleWorkList();
                        this.handleProductImageList();
                        this.handleAutGuarAnnexAttachmentsList();
                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },


            /**********校验下载链接********/
            checkDownloadUrl() {
                let downloadList = this.details.worksAttachments;
                if (downloadList && downloadList.length > 0) {
                    let reUrl01 = /^((ht|f)tps?):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
                    let downloadFlag = false;

                    for (let i = 0; i < downloadList.length; i++) {
                        if (!reUrl01.test(downloadList[i])) {
                            downloadFlag = false;
                            break
                        } else {
                            downloadFlag = true;
                        }
                    }
                    this.downloadFlag = downloadFlag;
                }

            },

            downloadHandle() {
                let downloadList = this.details.worksAttachments;
                for (let i = 0; i < downloadList.length; i++) {
                    console.log("downloadList[" + i + "] :: ", downloadList[i]);
                    download(1, downloadList[i], '')
                }
            },

            /**********创作声明文件********/
            DecFileFuc() {
                let copyrightType = this.details.copyrightType;
                let DecFile = [];

                switch (copyrightType) {

                    //合作作品
                    case '2': {
                        if (this.details.workCooperationThat) {
                            let fileList = (this.details.workCooperationThat || '').split(',');
                            for (let i = 0; i < fileList.length; i++) {
                                DecFile.push({name: '合作作品声明文件' + this.fileType(fileList[i]), url: fileList[i]});
                            }
                        }
                        break;
                    }

                    //法人作品
                    case  '3': {
                        if (this.details.workCorporate) {
                            let fileList = (this.details.workCorporate || '').split(',');
                            for (let i = 0; i < fileList.length; i++) {
                                DecFile.push({name: '法人作品声明文件' + this.fileType(fileList[i]), url: fileList[i]});
                            }
                        }
                        break;
                    }

                    //职务作品
                    case '4': {
                        if (this.details.workCorporate) {
                            let fileList = (this.details.workJobProduction || '').split(',');
                            for (let i = 0; i < fileList.length; i++) {
                                DecFile.push({name: '职务作品声明文件' + this.fileType(fileList[i]), url: fileList[i]});
                            }
                        }
                        break
                    }

                    //委托作品
                    case  '5': {
                        if (this.details.workCorporate) {
                            let fileList = (this.details.entrustStatementUrl || '').split(',');
                            for (let i = 0; i < fileList.length; i++) {
                                DecFile.push({name: '委托作品声明文件' + this.fileType(fileList[i]), url: fileList[i]});
                            }
                        }
                        break;
                    }

                    default:
                        break;

                }

                //创作声明
                if (this.details.subBizType == '0202' && (this.details.copyrightType == "2" || this.details.copyrightType == "4" || this.details.copyrightType == "5")) {
                    DecFile.push({
                        name: '创作声明' + this.fileType(this.details.workInstruction),
                        url: this.details.workInstruction
                    });
                }

                //其他材料信息声明文件
                if (this.details.otherAttachments && this.details.otherAttachments != '') {
                    let fileList = (this.details.otherAttachments || '').split(',');
                    for (let i = 0; i < fileList.length; i++) {
                        DecFile.push({name: '其他材料信息声明文件' + this.fileType(fileList[i]), url: fileList[i]});
                    }
                }

                this.DecFile = DecFile;
            },

            /**********文件类型判断********/
            fileType(filePath) {
                //获取最后一个.的位置
                let index = filePath.lastIndexOf(".");
                //获取后缀
                let ext = filePath.substr(index + 1);


                return (ext && ext != '' ? '.' + ext : '')
            },

            /**********处理作品文件********/
            handleWorkList() {
                let worksAttachmentses = this.details.worksAttachmentses;
                let workList = [];
                worksAttachmentses.forEach((value, index) => {
                    let obj = {};
                    obj.attachmentUrl = value.url;
                    let layout = value.url.substring(value.url.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        obj.url = util.thumbnail(value.url, '148', '168');
                    } else if (reMusic.test(layout)) {
                        obj.url = this.music;
                    } else if (reText.test(layout)) {
                        obj.url = this.text;
                    } else if (reVideo.test(layout)) {
                        obj.url = this.video;
                    } else {
                        obj.url = this.other;
                    }
                    obj.name = value.attachmentName;
                    obj.size = (value.attachmentSize) - 0;
                    workList.push(obj);
                });
                this.workList = workList;
            },

          handleProductImageList(){
            let productImageAttachmentses = this.details.productImageAttachments;
            if(productImageAttachmentses != '') {
              let productImageList = [];
              productImageAttachmentses.split(',').forEach((value, index) => {
                let obj = {};
                obj.attachmentUrl = value;

                obj.url = util.thumbnail(value, '148', '168');

                obj.name = '预览';
                obj.size = (value.attachmentSize) - 0;
                productImageList.push(obj);
              });
              this.productImageList = productImageList;
            }
          },

          handleAutGuarAnnexAttachmentsList(){
            let autGuarAnnexAttachments = this.details.autGuarAnnexAttachments;
            let autGuarAnnexList = [];
            autGuarAnnexAttachments.split(',').forEach((value, index) => {
              let obj = {};
              obj.name = '下载';
              obj.attachmentUrl = value;
              let layout = value.substring(value.lastIndexOf('.') + 1)
              if (reImg.test(layout)) {
                obj.name = '预览';
                obj.url = util.thumbnail(value, '148', '168');
              } else if (reMusic.test(layout)) {
                obj.url = this.music;
              } else if (reText.test(layout)) {
                obj.url = this.text;
              } else if (reVideo.test(layout)) {
                obj.url = this.video;
              } else {
                obj.url = this.other;
              }

              obj.size = (value.attachmentSize) - 0;
              autGuarAnnexList.push(obj);
            });
            this.autGuarAnnexList = autGuarAnnexList;
          },
        }
    }
</script>

<style scoped lang="less">

    .audit_status {
        width: 100%;
        text-align: center;
        height: 50px;
        padding: 15px 0;
        font-size: 14px;
        border: 1px solid #FF8800;
        box-sizing: border-box;
    }

    .audit_status.error {
        background: #ffcccc;
        color: #d81e06;
        border-color: #d81e06;

        .audit_text:before {
            content: '';
            padding-right: 30px;
            height: 20px;
            background: url(../user/more/authentication/images/audit_error.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: middle;
        }

    }


    .copyrightDetails {
        margin: 20px 0 50px;
        background: #FDFDFD;
    }

    .page_title {
        color: #323232;
        background: #fff;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.15);
        border-radius: 8px 8px 0 0;
        height: 50px;
        color: #323232;
        font-size: 16px;
        line-height: 50px;
        padding-left: 20px;
    }

    .details_group {
        width: 100%;
        overflow: hidden;
    }

    .details_group .details_item:nth-child(odd) .details_content_item {
        background: #fcfcfc;
    }

    .details_group .details_item:last-child .details_content_item {
        background: #fff;
    }

    .details_group .details_group_title {
        color: #323232;
        height: 51px;
        line-height: 51px;
        background: #F8F8F8;
        font-size: 16px;
        padding-left: 20px;
        display: flex;
        font-weight: bold;
    }

    .details_group_title .title_right {
        margin-left: auto;
        padding-right: 30px;
        color: #FFA400;
        font-size: 14px;
        cursor: pointer;
    }

    .details_group .details_content_item {
        padding: 20px 40px;
        background: #fff;
    }

    .details_content_item .details_content_item_list {
        display: flex;
        padding-bottom: 20px;
    }

    .details_content_item .details_content_item_list.img_group {
        white-space: nowrap;
        overflow-x: scroll;
    }

    .details_content_item .details_content_item_list:last-child {
        padding-bottom: 0;
    }

    .details_content_item_list .item_list_title {
        width: 131px;
        font-size: 16px;
        font-weight: 700;
    }

    .details_content_item_list .item_list_content {
        width: 301px;
    }

    .details_content_item_list .item_list_paragraph {
        width: 690px;
        color: #666666;
        line-height: 20px;
        white-space: normal;
    }

    .details_content_item_list .item_list_img {
        margin-right: 30px;
        text-align: center;
    }

    .item_list_img img {
        display: block;
        width: 148px;
        height: 168px;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.24);
        border-radius: 6px;
        background: #f5f5f5;
        margin: 0 auto;
        object-fit: cover
    }

    .item_list_img .item_list_desc {
        padding-top: 10px;
        display: block;
        color: inherit;
    }

    .details_content_item_list .item_list_content:last-child {
        flex: 1;
    }

    .details_content_item_list .cert_box {
        width: 485px;
        text-align: center;
    }

    .cert_box img {
        display: block;
        width: 485px;
        height: 340px;
        background: #f5f5f5;
    }

    .cert_box .download_btn {
        width: 214px;
        height: 40px;
        line-height: 40px;
        background: #FFD800;
        border-radius: 21px;
        color: #4E4E4E;
        font-size: 14px;
        margin: 20px auto 0;
        cursor: pointer;
        display: inline-block;
    }


</style>
